export default __webpack_public_path__ + "static/media/ic_snow.e016a045.svg";